import React, { Component } from "react";
import { bindActionCreators } from "redux";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import {
  USER_DETAILS,
  ADD_NOTIFICATION,
  EDIT_NOTIFICATION,
  NOTIFICATION_ACTIVITY_LOG,
} from "../../../../navigation/routes";

// import "./UserManagementStyles.scss";

import NotificationManagementView from "./NotificationManagementView";
import {
  getNotificationsList,
  addNewNotification,
  editNotification,
  deleteNotification,
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
} from "../../../../store/notificationManagement/notificationManagementActions";
import { history } from "../../../../store/configure/configureStore";

class NotificationManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: this?.props?.fields || {
        searchString: "",
      },
      notificationData: "",
      showModal: {
        showViewModal: false,
        showDeleteModal: false,
      },
      currentPage: this.props.currentPage || 1,
      rowsPerPage: this.props?.rowsPerPage || { label: "10", value: 10 },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTableRowsChange = this.handleTableRowsChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    //
    this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    this.stateUpdatesOnComponentUpdates(prevProps, prevState);
  }

  //--------------------------update state on component update
  stateUpdatesOnComponentUpdates = (prevProps, prevState) => {
    if (prevProps.currentPage !== this.props?.currentPage) {
      this.setState((prev) => ({
        ...prev,
        currentPage: this.props?.currentPage,
      }));
    }
  };

  componentDidMount() {
    this.fetchMobileAppUserList();
  }

  componentWillUnmount() {
    this.resetTheReduxStateOnUnmount();
  }

  resetTheReduxStateOnUnmount = () => {
    const location = window?.location?.pathname;
    if (
      !location?.includes(EDIT_NOTIFICATION) &&
      !location?.includes(ADD_NOTIFICATION) &&
      !location?.includes(NOTIFICATION_ACTIVITY_LOG)
    ) {
      //--------------------------reset redux rowsPerPage state when unmounting
      const resetRowsPerPageData = { label: "10", value: 10 };
      this.props?.updateRowsPerPage(resetRowsPerPageData);
      this.props?.updateCurrentPage(1);
      //--------------------------reset redux fields state when unmounting
      const resetFields = { searchString: "" };
      this.props.updateSearchFilters(resetFields);
    }
  };

  //--------------------------Modal handlers
  onClickView = (data) => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showViewModal: true },
      notificationData: data,
    }));
  };

  onClickDelete = (data) => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showDeleteModal: true },
      notificationData: data,
    }));
  };

  onCloseModal = () => {
    this.setState((prevState) => ({
      showModal: {
        showViewModal: false,
        showDeleteModal: false,
      },
    }));
  };

  //--------------------------field handlers

  handleInputChange = ({ target }) => {
    const field = target.name;
    // console.log(this.state.fields);
    this.setState({
      fields: { ...this.state.fields, [field]: target.value },
      errors: {},
    });
  };

  handleTableRowsChange = (value) => {
    this.setState(
      (prev) => ({ ...prev, rowsPerPage: value, currentPage: 1 }),
      () => this.fetchMobileAppUserList()
    );
  };

  handleChangePage = (page) => {
    console.log("page", page);

    this.setState(
      (prev) => ({ ...prev, currentPage: page }),
      () => this.fetchMobileAppUserList()
    );
  };

  //--------------------------Search user
  onChangeSearchInput = (e) => {
    const { value } = e.target;
    this.setState(
      (prev) => ({
        ...prev,
        fields: { ...prev.fields, searchString: value },
      }),
      () => {
        if (this.state.fields?.searchString === "") {
          this.fetchMobileAppUserList();
        }
        //update redux state
        this.props.updateSearchFilters(this?.state?.fields);
      }
    );
  };

  onClickSearch = () => {
    this.fetchMobileAppUserList(1);
  };

  handleClear = () => {
    // console.log(this.state.fields);
    this.setState(
      (prev) => ({
        ...prev,
        fields: { ...prev.fields, searchString: "" },
      }),
      () => {
        if (this.state.fields?.searchString === "") {
          this.fetchMobileAppUserList();
        }
        //update redux state
        this.props.updateSearchFilters(this?.state?.fields);
      }
    );
  };

  //--------------------------onClick handler

  onClickAddNewNotification = () => {
    history?.push(`${ADD_NOTIFICATION}`);
  };

  onClickEditNotification = (id) => {
    history?.push(`${EDIT_NOTIFICATION}/${id}`);
  };

  onClickConfirmDelete = (id) => {
    this.props?.deleteNotification(id, () => {
      this.fetchMobileAppUserList();
      this.onCloseModal();
    });
  };

  fetchMobileAppUserList = (page) => {
    const { searchString } = this.state?.fields;
    const { currentPage, rowsPerPage } = this.state;
    const data = {
      isActive: true,
      searchString: searchString,
    };
    this.props.getNotificationsList(
      data,
      page ? page : currentPage,
      rowsPerPage?.value
    );
  };

  render() {
    //--------------------------dropdown options

    const rowsPerPageDropDownOptions = [
      { label: "10", value: 10 },
      { label: "15", value: 15 },
      { label: "20", value: 20 },
      { label: "25", value: 25 },
      { label: "30", value: 30 },
    ];

    return (
      <NotificationManagementView
        //all the states
        fields={this.state?.fields}
        notificationData={this.state?.notificationData}
        showModal={this.state?.showModal}
        notificationList={this.props.notificationList}
        currentPage={this.state.currentPage}
        rowsPerPage={this.state?.rowsPerPage}
        //input handler
        onChangeSearchInput={this.onChangeSearchInput}
        handleInputChange={this.handleInputChange}
        handleTableRowsChange={this.handleTableRowsChange}
        handleChangePage={this.handleChangePage}
        handleClear={this.handleClear}
        //modal controls
        onClickView={this.onClickView}
        onClickDelete={this.onClickDelete}
        handleCloseModal={this.onCloseModal}
        //API's
        onClickSearch={this.onClickSearch}
        onClickAddNewNotification={this.onClickAddNewNotification}
        onClickEditNotification={this.onClickEditNotification}
        onClickConfirmDelete={this.onClickConfirmDelete}
        //dropdown options
        rowsPerPageDropDownOptions={rowsPerPageDropDownOptions}
        //permissions
        userPermissions={this.props.userPermissions}
      />
    );
  }
}

NotificationManagementContainer.propTypes = {};

const mapStateToProps = (state) => ({
  notificationList: state.notificationManagement.notificationList,
  fields: state.notificationManagement.fields,
  currentPage: state.notificationManagement.currentPage,
  rowsPerPage: state.notificationManagement.rowsPerPage,
  //
  userPermissions: state.auth.userPermissions,
});

export default connect(mapStateToProps, {
  getNotificationsList,
  deleteNotification,
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
})(NotificationManagementContainer);
